<template>
  <div  class="knowledgebox">
      <div class="bigTitle" @click="backFn('showa')"><span ></span>电子合同</div>
      <div class="smallTile" v-if="showa">
          <p>电子合同是双方或多方当事人之间通过电子信息网络以电子的形式达成的设立、变更、终止财产性民事权利义务关系的协议。</p>
      </div>
      <div class="bigTitle" @click="backFn('showb')"><span ></span>电子签名</div>
      <div class="smallTile" v-if="showb">
          <p>电子签名是指数据电文中以电子形式所含、所附用于识别签名人身份并表明签名人认可其中内容的数据。</p>
      </div>
      <div class="bigTitle" @click="backFn('showc')"><span ></span>数字证书</div>
      <div class="smallTile" v-if="showc">
          <p>数字证书就是互联网通讯中标志通讯各方身份信息的一串数字，提供了一种在Internet上验证通信实体身份的方式，数字证书不是数字身份证，而是身份认证机构盖在数字身份证上的一个章或印（或者说加在数字身份证上的一个签名），人们可以在网上用它来识别对方的身份</p>
      </div>
      <div class="bigTitle"  @click="backFn('showd')"><span></span>司法联盟链</div>
      <div class="smallTile" v-if="showd">
          <p>legalXchain司法联盟块链构建起法律、监管、政务的底层基础设施，是所有参与主体共识和协作的基础通信网络，连接不同司法机构职能体系的业务流和数据流，并将系统的服务能力更好的直接传递到公众。</p>
      </div>
      <div class="bigTitle" @click="backFn('showe')"><span ></span>电子合同法律效力</div>
      <div class="smallTile" v-if="showe">
          <p>《中华人民共和国合同法》第十一条：“书面形式是指合同书、信件和数据电文（包括电报、电传、传真、电子数据交换和电子邮件）等可以有形地表现所载内容的形式。”</p>
          <p>《中华人民共和国电子签名法》第十三条规定，电子签名同时符合下列条件的，视为可靠的电子签名：</p>
          <p>（一）电子签名制作数据用于电子签名时，属于电子签名人专有；</p>
          <p>（二）签署时电子签名制作数据仅由电子签名人控制；</p>
          <p>（三）签署后对电子签名的任何改动能够被发现；</p>
          <p>（四）签署后对数据电文内容和形式的任何改动能够被发现。</p>
          <p>《中华人民共和国电子签名法》第十四条：“可靠的电子签名与手写签名或者盖章具有同等的法律效力。”</p>
      </div>
      <div class="bigTitle" @click="backFn('showf')"><span></span>实名认证与电子合同签署</div>
      <div class="smallTile" v-if="showf">
          <p>为了保证所签署合同完整的法律效力，所有参与电子合同签署的用户必须在线提交个人身份信息进行实名认证，这是保障电子合同有效性的第一步。</p>
      </div>
      <div class="bigTitle"  @click="backFn('showg')"><span></span>电子数据存证</div>
      <div class="smallTile" v-if="showg">
          <p>智签电子合同签约平台为签约存证一体化平台，平台会将用户在平台上签署过程中产生的所有数据在生成时存证至司法联盟链，同步至链上所有节点，并跨链存证至北京互联网法院、杭州互联网法院和广州互联网法院，保证数据的真实性、原始性与不可篡改，当在纠纷出现时，让电子数据可以作为证据被法院所采信。</p>
      </div>
      <div class="bigTitle" @click="backFn('showh')"><span ></span>公证及其作用</div>
      <div class="smallTile" v-if="showh">
          <p>《中华人民共和国公证法》第二条：公证是公证机构根据自然人、法人或者其他组织的申请，依照法定程序对民事法律行为、有法律意义的事实和文书的真实性、合法性予以证明的活动。</p>
      </div>
      <div class="bigTitle" @click="backFn('showi')"><span ></span>司法鉴定及其作用</div>
      <div class="smallTile" v-if="showi">
          <p>司法鉴定是指在诉讼活动中鉴定人运用科学技术或者专门知识对诉讼涉及的专门性问题进行鉴别和判断并提供鉴定意见的活动。或者说，司法鉴定是指在诉讼过程中，对案件中的专门性问题，由司法机关或当事人委托法定鉴定单位，运用专业知识和技术，依照法定程序作出鉴别和判断的一种活动。</p>
      </div>
      <div class="bigTitle" @click="backFn('showl')"><span ></span>使用范围</div>
      <div class="smallTile" v-if="showl">
          <p>《电子签名法》第三条</p>
          <p>民事活动中的合同或者其他文件、单证等文书，当事人可以约定使用或者不使用电子签名、数据电文。</p>
          <p>当事人约定使用电子签名、数据电文的文书，不得仅因为其采用电子签名、数据电文的形式而否定其法律效力。</p>
          <p>前款规定不适用下列文书：</p>
          <p>（一）涉及婚姻、收养、继承等人身关系的；</p>
          <p>（二）涉及土地、房屋等不动产权益转让的；</p>
          <p>（三）涉及停止供水、供热、供气、供电等公用事业服务的；</p>
          <p>（四）法律、行政法规规定的不适用电子文书的其他情形。</p>
          <p>2019年4月3日，国务院常务会议通过了包括《电子签名法》在内的一批法律修正案草案（下称“修正案”），修改建议其中包括：允许在办理土地、房屋等转移登记时使用电子文书。</p>
      </div>
      <div class="bigTitle" @click="backFn('showj')"><span ></span>智签优势</div>
      <div class="smallTile" v-if="showj">
          <p>	全证据链通过区块链技术进行存证，同步至司法联盟链，联盟链节点全部参与共识，认可数据的真实性；</p>
          <p>符合GB/T 25064-2010信息安全技术公钥基础设施电子签名格式国家规范；</p>
          <p>时间戳服务符合国际通用时间戳标准规范RFC3161，采用国家标准时间源；</p>
          <p>可支持私有化部署，全面支持各种用户信息安全策略、行业监管标准要求（数据不出门），避免云方式数据泄露，第三方责任问题；</p>
          <p>签署的电子合同带有附页功能，附页中含有完整的签约数据链，同步存证于司法鉴定机构、公证机构、互联网法院，可直接作为证据被法院、仲裁采信；</p>
          <p>提供国内最权威电子合同存证服务，电文指纹信息由司法鉴定机构、公证处、互联网法院联合备案，必要时可以申请“司法鉴定意见书”与“公证书”；</p>
      </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      showa:false,
      showb:false,
      showc:false,
      showd:false,
      showe:false,
      showf:false,
      showg:false,
      showh:false,
      showi:false,
      showl:false,
      showj:false,
    }
  },
  methods:{
    backFn(flag){
      if(this[flag]==true){
        this[flag]=false;
      }else{
        this[flag]=true;
      }
    }
  }
}
</script>
<style lang="scss">
.knowledgebox{
  .smallTile{
    p{
      text-indent: 2em!important;
      line-height: 1.5;
      color:rgb(150,150,150)!important;
    }
  }
}
</style>
